import { render, staticRenderFns } from "./DeviceDeleteDialog.vue?vue&type=template&id=1bc2a820&scoped=true"
import script from "./DeviceDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./DeviceDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./DeviceDeleteDialog.vue?vue&type=style&index=0&id=1bc2a820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc2a820",
  null
  
)

export default component.exports